import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SecurityContext, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Editor, TOOLBAR_FULL } from 'ngx-editor';

@Component({ standalone: false, selector: 'app-rich-text-editor', templateUrl: './rich-text-editor.component.html', styleUrls: ['./rich-text-editor.component.scss'], encapsulation: ViewEncapsulation.None })
export class RichTextEditorComponent implements OnInit, OnDestroy {
  @Input() model = '';
  @Output() modelChange = new EventEmitter<string>();
  @Input() placeholder = 'Defina aqui el texto que ira en el pie de sus facturas';
  @Input() confKeys: string[] = [];
  @Input() datos: Record<string, string | null> = {};
  readonly toolbar = TOOLBAR_FULL;
  editor!: Editor;
  previewVisible = false;
  previewHtml = '';
  sourceMode = false;
  sourceCode = '';

  constructor(private readonly sanitizer: DomSanitizer) {}
  ngOnInit(): void { this.editor = new Editor(); }
  ngOnDestroy(): void { this.editor?.destroy(); }
  onModelChange(html: string): void { this.model = html; this.modelChange.emit(html); }
  insertCampo(key: string, selector?: HTMLSelectElement): void {
    if (key) this.editor.commands.insertText(key).exec();
    if (selector) selector.value = '';
  }
  toggleSourceMode(): void {
    this.sourceMode = !this.sourceMode;
    if (this.sourceMode) { this.sourceCode = this.model; return; }
    this.onModelChange(this.sourceCode);
    this.editor.setContent(this.sourceCode);
  }
  openPreview(): void {
    this.previewHtml = this.sanitizer.sanitize(SecurityContext.HTML, this.buildPreview()) || '';
    this.previewVisible = true;
  }
  handlePreviewCancel(): void { this.previewVisible = false; }
  private buildPreview(): string { return this.model.replace(/\$Conf_ID\d+/g, key => String(this.datos[key] ?? '')); }
}
